<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">文章管理</div>
      <div class="query">
        <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
      </div>
      <div class="table">
        <MyTable :table-options="tableOptions" border max-height="65vh">
          <template #handler="{ row }">
            <el-button
              style="color: #6fcaf7"
              icon="Edit"
              link
              @click="click_edit(row)"
              >编辑</el-button
            >
            <ConfirmButton
              style="color: #6fcaf7"
              icon="Delete"
              link
              @confirm="click_delete(row)"
              >删除</ConfirmButton
            >
          </template>
        </MyTable>
        <MyPagination :params="paginationParams" :total="total" @get-list="getList" ref="paginationRef" />
      </div>
    </div>
    <!-- 新增 -->
    <Dialog
      width="50%"
      v-model="dialogVisible"
      title="新增"
      top="5vh"
    >
      <MyForm
        class="add-user-form"
        :formOptions="addUserForm"
        :inline="true"
        ref="myFormRef"
        label-width="auto"
      >
        <template #isEnable="{ formData }">
           <el-switch v-model="formData.isEnable" />
        </template>
        <template #cover="{ formData }">
          <ImgUpload  v-model="formData.cover" />
        </template>
        <template #content="{ formData }">
             <RichText
                 class="column-span2"
                v-model="formData.content"
                style="height: 350px;"
                defaultUpload
                ref="editorRef"
                :readonly="readonly"
            />
        </template>
      </MyForm>
      <div class="submit-buttons">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button @click="click_addUser_confirm">确定</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import MyTable from "@/components/Global/MyTable.vue";
import { computed, nextTick, reactive, ref } from "vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import { genFileId, ElMessage } from "element-plus";
import Dialog from "@/components/Common/Dialog.vue";
import ImgUpload from "@/components/Common/ImgUpload.vue";
import {postPatientEducation,getPatientEducation,deletePatientEducation,putPatientEducation} from "@/api/PatientEducation"
import dictionary from "@/api/dict.js";
import RichText from "@/components/RichText.vue";

// 搜索
const queryForm = reactive({
  itemList: [
    {
      type: "Input",
      label: "关键字：",
      prop: "Name",
      attrs:{
        placeholder: "请输入关键词"
      }
    },
    [
      {
        type: "Button",
        value: "查询",
        attrs: {
          icon: "Search",
        },
        events: {
          click(formData) {
            paginationParams.Name = formData.Name;
          },
        },
      },
      {
        type: "Button",
        value: "添加",
        attrs: {
          icon: "Plus",
        },
        events: {
          click(formData) {
            Flag.value = 0;
            dialogVisible.value = true;
          },
        },
      },
    ]
  ],
});

const tableOptions = reactive({
  colList: [
    { type: "index", label: "序号", width: 70 },
    { label: "标题", prop: "title" },
    { label: "说明", prop: "remarks" },
    { label: "标签", prop: "label" },
    // { label: "内容", prop: "content" },
    { type: "slot", slot_name: "handler", label: "操作", width: 200 },
  ],
  tableData: [],
});

// 分页
const paginationParams = reactive({
  KeyId: 22,
})
const paginationRef = ref(null);
const total = ref(0);
const getList = (params = paginationRef.value.getList_params) => {
  getPatientEducation(params).then((res) => {
    total.value = res.data.totalCount;
    tableOptions.tableData = res.data.items
  })
}
//字典类别
const articleList = ref([]);
const getArticleListData = () => {
  dictionary.getList({
    OrganizationId:"3a1dcd29-4d09-736f-1174-7ae7b6d32b3f",
    Code: "science",
  }).then((res) => {
    console.log(res,"类别")
    articleList.value = res.data.items.map(item=>{
      return {
        label: item.name,
        value: item.id,
        ...item
      }
    });
  })
}
getArticleListData();


const dialogVisible = ref(false);
const itemList = computed(() => {
  const base = [
    {
      type: "Select",
      label: "文章类别：",
      prop: "keyId",
      options: articleList,
      attrs:{
        placeholder: "请选择"
      }
    },
    {
      type: "Input",
      label: "标题",
      prop: "title",
      attrs:{
        placeholder: "请输入标题"
      }
    },
    {
      type: "Input",
      label: "说明",
      prop: "remarks",
      attrs:{
        placeholder: "请输入说明"
      }
    },
    {
      type: "Input",
      label: "标签",
      prop: "label",
      attrs:{
        placeholder: "请输入标签"
      }
    },
    {
      type: "Slot",
      label: "是否启用：",
      prop: "isEnable",
      slot_name: "isEnable",
    },
    {
      type: "Slot",
      label: "封面",
      prop: "cover",
      slot_name: "cover",
    },
    {
      type: "Slot",
      label: "内容",
      prop: "content",
      slot_name: "content",
    },
  ];
  return base;
});

const Flag = ref(0);
const readonly = computed(() => Flag.value === 2); //只读
const addUserForm = reactive({
  itemList: itemList,
  rules: {
    title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
    remarks: [{ required: true, message: "说明不能为空", trigger: "blur" }],
    label: [{ required: true, message: "标签不能为空", trigger: "blur" }],
    cover: [{ required: true, message: "封面不能为空", trigger: "blur" },],
    content: [{ required: true, message: "内容不能为空", trigger: "blur" }],
  },
  commonAttrs: {
    readonly,
  },
});



// 添加文章
const myFormRef = ref(null);
const click_addUser_confirm = () => {
  if (Flag.value === 2) return (dialogVisible.value = false); //查看
  const { formRef, formData } = myFormRef.value;
  formRef.validate(async(valid) => {
    if (valid) {
      let res = formData.id ? await putPatientEducation(formData)
      : await postPatientEducation(formData);
      ElMessage.success("操作成功");
      dialogVisible.value = false;
      getList();
    }
  })
};


const click_edit = async(row) => {
  // Flag.value = 1;
  dialogVisible.value = true;
  await nextTick();
  const { formData } = myFormRef.value;
  Object.assign(formData, row);
}
const click_delete = (row) => {
  deletePatientEducation(row.id).then((res) => {
    ElMessage.success("删除成功");
    getList();
  })
}
</script>

<style lang="scss" scoped>
.add-user-form {
  padding: 0 50px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  :deep(){
    .el-input,.el-select {
      width: 100%;
      height: 40px;
    }
    .el-select__wrapper{
      width: 100%;
      height: 100%;
    }
    .el-form-item:has(.row-span2){
      grid-row-start: span 2;
      .el-textarea,.el-textarea__inner{
        height: 100%;
      }
    }
    .el-form-item:has(.column-span2){
      grid-column-start: span 2;
    }
  }
}
</style>
